var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_773_1346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 10H8.00016C7.63197 10 7.3335 10.2985 7.3335 10.6667V16C7.3335 16.3682 7.63197 16.6667 8.00016 16.6667H13.3335C13.7017 16.6667 14.0002 16.3682 14.0002 16V14",
    stroke: "currentColor",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.99998C10 7.63179 10.2985 7.33331 10.6667 7.33331H16C16.3682 7.33331 16.6667 7.63179 16.6667 7.99998V13.3333C16.6667 13.7015 16.3682 14 16 14H10.6667C10.2985 14 10 13.7015 10 13.3333V7.99998Z",
    stroke: "currentColor",
    strokeWidth: 1.06667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_773_1346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.de2cfdeb1570b1b79a6741b4678c2fa7.svg";
export { ForwardRef as ReactComponent };